import React from "react";
import { useLowData } from "@/context/LowDataContext";
import { Battery, BatteryLow } from "lucide-react";

/** Small pill button — floats bottom-left, above WhatsApp; toggles low-data mode. */
export default function LowDataToggle() {
  const { lowData, toggle } = useLowData();
  return (
    <button
      onClick={toggle}
      className={`fixed bottom-24 left-4 z-40 px-3 py-2 rounded-full shadow-lg text-[12px] font-semibold flex items-center gap-1.5 transition-colors ${
        lowData ? "mv-green-bg text-white" : "bg-white mv-green-text border mv-hairline"
      }`}
      data-testid="low-data-toggle"
      aria-label={lowData ? "Turn off low data mode" : "Turn on low data mode"}
    >
      {lowData ? <BatteryLow size={14}/> : <Battery size={14}/>}
      {lowData ? "Low-Data ON" : "Low-Data"}
    </button>
  );
}
